import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import DynamicTable from '../../DynamicTable';
import { visitInertia } from '../../../../helpers/Navigation';
const DossierTable = ({ dossiers, loading }) => {
    const { t } = useTranslation();
    function transformNested(row, property) {
        let value = row;
        if (property.includes('.') && typeof row === 'object') {
            const nestedProperties = property.split('.');
            nestedProperties.forEach((nestedProperty) => {
                value = value[nestedProperty];
            });
            // @ts-ignore value can be number due to change in for each
            if (typeof value === 'number') {
                return `${value}`;
            }
            if (value) {
                // @ts-ignore value can be string due to change in for each
                return value;
            }
        }
        return null;
    }
    // @ts-ignore
    return (_jsx(DynamicTable, { id: "dossier-requests-table", data: dossiers, loading: loading, onRowClick: (dossier, event) => visitInertia(`/dossier/${dossier.id}/verzoeken`, event, true), noData: () => t(`dossiers.requests.no_result`), config: [
            {
                property: 'request.dossier_number',
                columnName: 'dossier.number_abbr',
                align: 'left',
                visible: true,
                transformNested: (row, value) => transformNested(row, value),
            },
            {
                property: 'debtor_name',
                columnName: 'dossier.debtor',
                align: 'left',
                visible: true,
            },
            {
                property: 'request.type',
                columnName: 'type',
                align: 'left',
                visible: true,
                transformNested: (row, value) => t('dossiers.requests.type.' +
                    transformNested(row, value)),
            },
            {
                property: 'request.status',
                columnName: 'dossier.status',
                align: 'left',
                visible: true,
                transformNested: (row, value) => t('dossiers.requests.status.' +
                    transformNested(row, value)),
            },
            {
                property: 'request.requested_at',
                columnName: 'dossiers.requests.requested_at',
                align: 'left',
                visible: true,
                noWrap: true,
                transformNested: (row, value) => typeof transformNested(row, value) === 'string'
                    ? new Date(
                    // @ts-ignore type is string
                    transformNested(row, value)).toLocaleDateString('nl-nl', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })
                    : null,
            },
        ] }));
};
export default DossierTable;
